import { SessionStorageService } from './../../storage/sessionStorage.service';
import { LocalService } from './../../storage/localService';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AccesoService } from '../../acceso/acceso.service';
import { FiltrosDesembolso } from 'app/models/FiltrosDesembolso';
import { filter, pluck } from "rxjs/operators";
import { Observable} from "rxjs";
@Injectable({
    providedIn: 'root'
})

export class DesembolsoService {

    message: Observable<any>;
    readonly urlBase = environment.rutaBase;
    header : HttpHeaders;
    idEmpresa_Factor : any;

    constructor(private http: HttpClient, 
                private accesoService:AccesoService,
                private sessionStorageService: SessionStorageService,
                private localService : LocalService){
        this.header = this.accesoService.desencriptarTOKEN();
        this.datoStorage()
    }

    datoStorage(){
        this.message = this.sessionStorageService.storageChange$.pipe(
          filter(({ storageArea }) => storageArea === "sessionStorage"),
          filter(({ key }) => key === '1cefada07eb9',),
          pluck("value")
        );
       this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
       if (this.idEmpresa_Factor == undefined) {
        this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
       } 
    }

    FiltroListadoDesembolso(Filtros: FiltrosDesembolso,fechaD:any, fechaH:any){
        let headers = this.header;
        return this.http.get(`${this.urlBase}/Desembolso?idEmpresa_Factor=${this.idEmpresa_Factor}&NumeroPagina=1&NumeroRegistro=100000&tipo=${Filtros.Tipo}&IdAdquirente=${Filtros.IdAd}&IdProveedor=${Filtros.IdProv}&Estado=${Filtros.Estado}&FechaInicial=${fechaD}&FechaFinal=${fechaH}&Moneda=${Filtros.Moneda}`,{headers});        
    }

    aprobarEstadoDesembolso(body:any){
        let headers = this.header;
        return this.http.put(`${this.urlBase}/Desembolso/Aprobar?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
    }

    crearDesembolso(body:any){
        let headers = this.header;
        return this.http.post(`${this.urlBase}/Desembolso?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
    }
    
    downloadTXTPlanillaDesembolso(idDesembolso:number){
        let headers = this.header;
        return this.http.get(`${this.urlBase}/Desembolso/Planilla?idEmpresa_Factor=${this.idEmpresa_Factor}&idDesembolso=${idDesembolso}`,{headers})    
    }
    
    downloadTXTPlanillaDesembolsoBBVA(idDesembolso:number){
        let headers = this.header;
        return this.http.get(`${this.urlBase}/Desembolso/PlanillaBBVA?idEmpresa_Factor=${this.idEmpresa_Factor}&idDesembolso=${idDesembolso}`,{headers})
    }
    
    confirmarEstadoDesembolso(body:any){
       let headers = this.header;
        return this.http.put(`${this.urlBase}/Desembolso/Confirmar?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
    }

    obtenerDesembolsoCab(idDesembolso:number){
        let headers = this.header;
        return this.http.get(`${this.urlBase}/DesembolsoCab?idEmpresa_Factor=${this.idEmpresa_Factor}&idDesembolso=${idDesembolso}`,{headers})
    }

    obtenerDesembolsoDet(idDesembolso:number){
        let headers = this.header;
        return this.http.get(`${this.urlBase}/DesembolsoDet?idEmpresa_Factor=${this.idEmpresa_Factor}&idDesembolso=${idDesembolso}`,{headers})
    }

    bajaEstadoDesembolso(body:any){
        let headers = this.header;
        return this.http.put(`${this.urlBase}/Desembolso/Estado?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
    }

    DownloadPdfPlanillaDesembolso(idDesembolso:any){
        let headers = this.header;
        return this.http.get(`${this.urlBase}/DownloadPdfPlanillaDesembolso?idEmpresa_Factor=${this.idEmpresa_Factor}&idDesembolso=${idDesembolso}`,{headers});
    }

    crearDesembolsoLiquidacion(body:any){
        let headers = this.header;
        return this.http.post(`${this.urlBase}/CrearPlanillaDesembolsoLiquidacion?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
    }

    DownloadPdfPlanillaRemanente(idDesembolso:any){
        let headers = this.header;
        return this.http.get(`${this.urlBase}/DownloadPdfPlanillaRemanente?idEmpresa_Factor=${this.idEmpresa_Factor}&idDesembolso=${idDesembolso}`,{headers});
    }

    ObtenerAnexoContrato(Opcion: any, idDesembolso: any,idSolicitudDesembolso:any){
        let headers = this.header;
        return this.http.get(`${this.urlBase}/CheckPlanilla?idEmpresa_Factor=${this.idEmpresa_Factor}&opc=${Opcion}&idDesembolso=${idDesembolso}&idSolicitudDesembolso=${idSolicitudDesembolso}`,{headers});
    }
    
    confirmarEstadoDesembolsoRemanente(body:any){
        let headers = this.header;
         return this.http.put(`${this.urlBase}/Desembolso/ConfirmarRemanente?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
     }
}